(() => {
  const initialized = new WeakSet();
  const activeForms = new Set();

  function initialize(scope = document) {
    scope.querySelectorAll('[data-monarch-form-state]').forEach((state) => {
      const form = state.closest('form');
      if (!form || initialized.has(form)) return;
      initialized.add(form);

      const pending = state.querySelector('[data-form-pending]');
      const clientError = state.querySelector('[data-form-client-error]');
      const serverResult = state.querySelector('[data-form-errors], [data-form-success]');
      let timer;
      let submitting = false;
      let activeSubmitEvent = null;

      function clearPending() {
        window.clearTimeout(timer);
        submitting = false;
        activeSubmitEvent = null;
        form.removeAttribute('aria-busy');
        pending.hidden = true;
        activeForms.delete(clearPending);
      }

      function showError(message) {
        clearPending();
        clientError.textContent = message;
        clientError.hidden = false;
        clientError.focus();
      }

      if (serverResult) serverResult.focus();

      form.addEventListener('input', (event) => {
        if (event.target.matches('[aria-invalid="true"]')) {
          event.target.removeAttribute('aria-invalid');
        }
      });

      form.addEventListener('submit', (event) => {
        if (event.defaultPrevented) return;
        if (!navigator.onLine) {
          event.preventDefault();
          showError(state.dataset.offlineMessage);
          return;
        }
        if (submitting) {
          if (activeSubmitEvent?.defaultPrevented) {
            clearPending();
          } else {
            event.preventDefault();
            return;
          }
        }
        submitting = true;
        activeSubmitEvent = event;
        form.setAttribute('aria-busy', 'true');
        pending.hidden = false;
        clientError.hidden = true;
        activeForms.add(clearPending);
        timer = window.setTimeout(() => showError(state.dataset.slowMessage), 20000);
        queueMicrotask(() => {
          if (activeSubmitEvent === event && event.defaultPrevented) clearPending();
        });
      });
    });
  }

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  window.addEventListener('pageshow', () => {
    activeForms.forEach((clearPending) => clearPending());
  });
})();
